module.exports = __webpack_public_path__ + "static/media/phone-speaker.15b2c59c.svg";